export const SHEET_ANALYTICS_DEBOUNCE_MS = 350;
export const SHEET_ANALYTICS_CACHE_LIMIT = 20;

export const scheduleSheetAnalyticsCalculation = (callback, delay = SHEET_ANALYTICS_DEBOUNCE_MS) => {
  const timer = window.setTimeout(callback, delay);
  return () => window.clearTimeout(timer);
};

export const setBoundedSheetAnalyticsCacheEntry = (
  cache,
  key,
  value,
  limit = SHEET_ANALYTICS_CACHE_LIMIT
) => {
  cache.delete(key);
  cache.set(key, value);
  while (cache.size > limit) {
    cache.delete(cache.keys().next().value);
  }
};
